<template>
  <div>
    <section class="content-header">
      <h1>{{ $t('post.edit', { entity: retrieved && retrieved.id }) }}</h1>
    </section>

    <section class="content">
      <div class="box box-primary">
        <div class="box-body">
          <item-update-errors entity="post" :is-loading="isLoading"></item-update-errors>

          <PostForm
            v-if="!isLoading"
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :values="retrieved"
            :errors="violations" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PostForm from './Form.vue'
import ItemUpdateErrors from '../layout/errors/ItemUpdateErrors'

export default {
  components: {
    ItemUpdateErrors,
    PostForm,
  },

  computed: {
    ...mapGetters({
      isLoading: 'post/update/isLoading',
      deleted: 'post/del/deleted',
      retrieved: 'post/update/retrieved',
      violations: 'post/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'PostList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'post/create/reset',
      delReset: 'post/del/reset',
      retrieve: 'post/update/retrieve',
      updateReset: 'post/update/reset',
      update: 'post/update/update',
      updateRetrieved: 'post/update/updateRetrieved'
    }),

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update().then(item => {
        this.$router.push({ name: 'PostShow', params: { id: item['@id'] } })
      }).catch(e => {})
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/post/Update.vue